<template>
    <div>
      <HorizontalTopbarInside />
      <b-container v-if="vacancy_application" style=" border-radius: 15px; margin-top: 170px; padding: 0">
        <AppBreadcrumb />
        <b-card class="cardy">
          <header class="header">
            <h3 style="color: #185d89"
            >{{$t('Job description')}}
            </h3>
          </header>
          <b-row >
            <div class="ql-editor" v-html="vacancy_application.description"></div>
          </b-row>
        </b-card>
      </b-container>
      <b-container style=" border-radius: 15px">

<!--          <header class="header1" style="background-color: #185d89">-->
<!--            <h3-->
<!--            >{{$t('message.Candidates_for_positions')}}-->
<!--            </h3>-->
<!--          </header>-->
        <b-card>
<!--        <b-table-->
<!--            striped hover-->
<!--            class="w-100"-->
<!--            responsive-->
<!--            :items="applications"-->
<!--            :fields="fields">-->
<!--          <template #cell(no)="data">-->
<!--            <span>{{data.index+1}}</span>-->
<!--          </template>-->

<!--          <template #cell(created_at)="{item}">-->
<!--            <span>{{item.created_at | formatDate}}</span>-->
<!--          </template>-->

<!--        </b-table>-->
          <b-button
              style="margin-left: 450px;
              background-color: #185d89;
              margin-bottom: 70px "
              variant="primary"
              class="text-white"
              size="lg"
              @click="$router.push({name: 'fregister', params: {vacancyId: $route.params.id}})"
              v-if="isValidPosition"
          >
            {{$t('Click to apply')}}
          </b-button>
          <div v-else class="text-center mt-4">
            <h5>{{$t('message.VacancyApplicationEnded')}}</h5>
          </div>
        </b-card>
      </b-container>
    </div>
</template>

<script>
import {showAllFJobs} from "../../../../api/school_job_vacancy";
import {getGlobalFApplications} from "../../../../api/school-vacany-applications";
import HorizontalTopbarInside from "../../../../components/horizontal-topbar-inside";
import moment from "moment";
import AppBreadcrumb from "../../../layouts/AppBreadcrumb";

import 'quill/dist/quill.snow.css'

export default {
  name: "RankInformation",
  data() {
    return {
      selected: null,
      vacancy_application:null,
      options: [
        { value: null, text: 'Hudud (Tuzilma)' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'Selected Option' },
      ],
      fields: [
        {
          key: 'no',
          label:'No'
        },
        {
          key: 'fio',
          label: this.$t('message.FullName')
        },
        {
          key: 'mobile',
          label: this.$t('message.Applicant_phone_number')
        },
        {
          key: 'id',
          label: this.$t('message.ContactNumber')
        },
        {
          key: 'created_at',
          label: this.$t('message.Time_of_reference')
        },
        {
          key: 'cur_status.name',
          label: this.$t('message.Status')
        },
        {
          key: '',
          label: this.$t('message.Comment_employer')
        },
      ],
      applications: [],
    }
  },
  filters:{
    formatDate(val) {
      return moment(val).format('DD-MM-YYYY')
    }
  },
  components:{
    AppBreadcrumb,
    HorizontalTopbarInside,
  },
  created() {
  this.fetchAllJobs()
    this.fetchApplications()
  },
  computed:{
    isValidPosition() {
      return this.vacancy_application ? moment(this.vacancy_application.deadline).isAfter(moment()) : false;
    }
  },
  methods:{
    fetchAllJobs(){
      showAllFJobs(this.$route.params.id).then(response => {
        this.vacancy_application = response.data.data
        // eslint-disable-next-line no-console
        console.log(this.vacancy_application)
      })
    },
    fetchApplications() {
      getGlobalFApplications({vacancy_id: this.$route.params.id}).then(res => {
        this.applications = res.data.data.data;
      })
    }
  },
}
</script>

<style scoped>
h2 {
  text-align: center;
  color: #4d63cf;
}
h3 {
  text-align: center;
  color: #ffffff;
}
.btn{
  color:  #4d63cf;
  margin-left: 450px;
  margin-top: 60px;
}
.header{
  background-color: #f7ba3e;
  border-radius: 15px 15px 0px 0px;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
}
.header1{
  background-color: #4d63cf;
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 15px 15px 0px 0px;
}
span{
  font-weight: normal;
}
.cardy{
  padding: 0 !important;
}
</style>
